import { Controller } from "@hotwired/stimulus";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";

// PhotoSwipe lightbox over every `a.lightbox-item` inside the element
// (including visually hidden ones, so "View all N photos" covers the whole
// gallery). Photo titles ride along as data-caption and render as a bottom
// caption bar.
export default class extends Controller {
  connect() {
    this.lightbox = new PhotoSwipeLightbox({
      gallery: this.element,
      children: "a.lightbox-item",
      pswpModule: () => import("photoswipe"),
    });
    this.lightbox.on("uiRegister", () => {
      this.lightbox.pswp.ui.registerElement({
        name: "caption",
        appendTo: "root",
        onInit: (el, pswp) => {
          pswp.on("change", () => {
            el.textContent =
              pswp.currSlide?.data?.element?.dataset?.caption || "";
          });
        },
      });
    });
    this.lightbox.init();
  }

  open(event) {
    event.preventDefault();
    this.lightbox?.loadAndOpen(0);
  }

  disconnect() {
    this.lightbox?.destroy();
    this.lightbox = null;
  }
}
